import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M6.75 13.5q-.619 0-1.059-.44A1.45 1.45 0 0 1 5.25 12V3q0-.619.441-1.059T6.75 1.5h6.75q.619 0 1.06.441Q15 2.382 15 3v9q0 .619-.44 1.06a1.44 1.44 0 0 1-1.06.44zm0-1.5h6.75V3H6.75zm-3 4.5q-.619 0-1.059-.44A1.45 1.45 0 0 1 2.25 15V5.25q0-.319.216-.534A.73.73 0 0 1 3 4.5q.318 0 .535.216a.72.72 0 0 1 .215.534V15h7.5q.319 0 .535.216a.72.72 0 0 1 .215.534q0 .319-.216.535a.72.72 0 0 1-.534.215z"
    }, null, -1)
  ]))]))
}
export default { render: render }